// extracted by mini-css-extract-plugin
export default {"submitButton":"SubmitButton_submitButton__17+aO"};